interface IProps {
	children: React.ReactNode;
}

const LayoutSignIn: React.FC<IProps> = ({children}) => (
	<div data-testid="layoutId">
		<div>
			<meta charSet="utf-8" />
			<meta
				name="viewport"
				content="width=device-width, initial-scale=1, shrink-to-fit=no"
			/>
			<meta name="description" content="" />
			<meta name="author" content="Summa Networks" />
			<meta name="generator" content="" />
			<title>PCRF v1.0</title>
			<link rel="canonical" href="" />
			{/* Bootstrap core CSS */}
			<link
				rel="stylesheet preload"
				as="style"
				href="../assets/css/bootstrap.min.css"
			/>
			<link
				rel="stylesheet preload"
				as="style"
				href="../assets/css/bootstrap-icons.css"
			/>
			{/* Custom styles for this template */}
			<link href="../assets/css/pcrf.css" rel="stylesheet" />
			{/* Favicons
				<link rel="apple-touch-icon" href="/docs/4.6/assets/img/favicons/apple-touch-icon.png" sizes="180x180">
				<link rel="icon" href="/docs/4.6/assets/img/favicons/favicon-32x32.png" sizes="32x32" type="image/png">
				<link rel="icon" href="/docs/4.6/assets/img/favicons/favicon-16x16.png" sizes="16x16" type="image/png">
				<link rel="manifest" href="/docs/4.6/assets/img/favicons/manifest.json">
				<link rel="mask-icon" href="/docs/4.6/assets/img/favicons/safari-pinned-tab.svg" color="#563d7c">
				<link rel="icon" href="/docs/4.6/assets/img/favicons/favicon.ico">
				<meta name="msapplication-config" content="/docs/4.6/assets/img/favicons/browserconfig.xml">
				*/}
			<meta name="theme-color" content="#563d7c" />
		</div>

		<div className="container">
			{/* <!-- Outer Row --> */}
			{children}
		</div>
	</div>
);

export default LayoutSignIn;
